import "./facets";
import "./filter-drawer";

class MainCollection extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (e) => {
      const loadMore = e.target.closest("[data-load-more]");

      if (!loadMore) return;

      e.preventDefault();
      const productGrid = this.querySelector("[data-product-grid]");

      fetch(loadMore.href)
        .then((response) => response.text())
        .then((response) => {
          const doc = new DOMParser().parseFromString(response, "text/html");

          const newLoadMore = doc.querySelector("[data-load-more]");
          if (!newLoadMore) {
            loadMore.style.display = "none";
          } else {
            loadMore.href = newLoadMore.href;
            loadMore.setAttribute(
              "data-current-page",
              newLoadMore.getAttribute("data-current-page"),
            );
            loadMore.innerHTML = newLoadMore.innerHTML;
          }

          const newProgress = doc.querySelector(
            ".main-collection__load-more-progress-wrapper",
          );
          this.querySelector(
            ".main-collection__load-more-progress-wrapper",
          ).innerHTML = newProgress.innerHTML;

          const newProductCards = doc.querySelectorAll("[data-product-card]");

          productGrid.append(...newProductCards);

          newProductCards[0].querySelector("a")?.focus();
        });
    });
  }
}

if (!customElements.get("main-collection")) {
  customElements.define("main-collection", MainCollection);
}
